import { defineComponent as _defineComponent } from 'vue'
import { DdPage, DeletedDdPage } from "@/CodegenTypes";
import { queries } from "@/apollo";
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import DdEntryTables from "./DdEntryTables.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeletedPageDetailsModal',
  props: {
    pageId: null,
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  pageId?: DdPage["id"];
  value: boolean;
};



const { result: deletedPageResult, loading } = useQuery<{
  deletedPage: DeletedDdPage;
}>(queries.deletedPage, {
  id: computed(() => props.pageId),
});

const deletedPage = computed(() => {
  return deletedPageResult.value?.deletedPage;
});



function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, deletedPageResult, loading, deletedPage, emit, toggleModal, DdEntryTables }
}

})